export default __webpack_public_path__ + "static/media/portfolio-117.462deb35.jpg";